export const actionTypes = {
    SUBDOMAIN_FETCH_TILE_LAYER: 'SUBDOMAIN/FETCH_TILE_LAYER',
    SUBDOMAIN_FETCH_TILE_LAYER_SUCCESS: 'SUBDOMAIN/FETCH_TILE_LAYER_SUCCESS',
    SUBDOMAIN_TILE_LAYER_SET_ACTIVE: 'SUBDOMAIN/TILE_LAYER_SET_ACTIVE',
    SUBDOMAIN_TILE_LAYER_SET_INACTIVE: 'SUBDOMAIN/TILE_LAYER_SET_INACTIVE',
};
